// lots of disabled linting because i'm not perfecting a hack

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable functional/no-try-statement */
/* eslint-disable functional/no-this-expression */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable functional/immutable-data */

import { dispatchSignInInfoEvent } from "./dispatchSignInInfoEvent";

/**
 * https://gist.github.com/sergeimuller/a609a9df7d30e2625a177123797471e2
 */
export function setupInterceptTokenHack() {
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function () {
    this.addEventListener("load", function () {
      try {
        const parsed = JSON.parse(this.responseText);
        if (parsed?.access_token !== undefined) {
          dispatchSignInInfoEvent(parsed);
        }
      } catch {
        // probably just a different request
      }
    });
    origOpen.apply(this, arguments as any);
  };
}
